module.exports = __webpack_public_path__ + "img/comm2_uc.aafab4db.webp";